import { render, staticRenderFns } from "./HistoryFilter.vue?vue&type=template&id=37d7e52b&"
import script from "./HistoryFilter.vue?vue&type=script&lang=js&"
export * from "./HistoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./HistoryFilter.vue?vue&type=style&index=0&id=37d7e52b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports